class SearchAutosuggest {
  constructor(comboboxNode) {
    this.MAX_SUGGESTIONS = 10;
    this.MAX_DEV_SUGGESTIONS = 5;
    this.comboboxNode = comboboxNode;

    this.comboboxHasVisualFocus = false;
    this.listboxHasVisualFocus = false;

    this.hasHover = false;

    this.suggestionsLoading = false;
    this.suggestionOptions = [];
    this.listboxElements = [];

    this.option = null;
    this.firstOption = null;
    this.lastOption = null;

    this.filteredOptions = [];
    this.filter = '';
    this.timeoutID = null;

    let form = this.comboboxNode.closest('form');
    this.searchButton = form.querySelector('.update--button');

    this.isSearchResultsForm = false;
    this.initialLocation = '';
    let initialLocationField = form.querySelector('.location-filter--initial');
    if (initialLocationField) {
      this.initialLocation = initialLocationField.value;
      this.isSearchResultsForm = true;
    }

    // variable used to identify key pressed if missing from KeyUp event
    this.keyDownFieldValue = '';

    // Add the aria-autocomplete
    this.comboboxNode.setAttribute('aria-autocomplete', 'list');

    // create the listbox node
    this.listboxNode = document.createElement('ul');
    this.listboxNode.id = `${this.comboboxNode.id}-cb1-listbox`;
    this.listboxNode.classList.add('autosuggest-listbox');
    this.listboxNode.setAttribute('role', 'listbox');
    this.listboxNode.setAttribute('aria-label', 'Locations');
    this.listboxNode.style.display = 'none';

    this.comboboxNode.parentNode.insertBefore(this.listboxNode, this.comboboxNode.nextSibling);


    // initialise Bing Maps Autosuggest Manager
    this.autosuggestOptions = { maxResults: this.MAX_SUGGESTIONS, countryCode: 'GB' };
    this.autoSuggestManager = new Microsoft.Maps.AutosuggestManager(this.autosuggestOptions);

    this.comboboxNode.addEventListener(
      'keydown',
      this.onComboboxKeyDown.bind(this)
    );
    this.comboboxNode.addEventListener(
      'keyup',
      this.onComboboxKeyUp.bind(this)
    );
    this.comboboxNode.addEventListener(
      'click',
      this.onComboboxClick.bind(this)
    );
    this.comboboxNode.addEventListener(
      'focus',
      this.onComboboxFocus.bind(this)
    );
    this.comboboxNode.addEventListener(
      'blur',
      this.onComboboxBlur.bind(this))
      ;
    this.comboboxNode.addEventListener(
      'paste',
      this.onComboboxPaste.bind(this)
    );

    this.comboboxNode.addEventListener(
      'cut',
      this.onComboboxCut.bind(this)
    );

    document.body.addEventListener(
      'pointerup',
      this.onBackgroundPointerUp.bind(this),
      true
    );

    // initialize pop up menu

    this.listboxNode.addEventListener(
      'pointerover',
      this.onListboxPointerover.bind(this)
    );
    this.listboxNode.addEventListener(
      'pointerout',
      this.onListboxPointerout.bind(this)
    );

  }

  getLowercaseContent(node) {
    return node.textContent.toLowerCase();
  }

  isOptionInView(option) {
    let bounding = option.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  setActiveDescendant(option) {
    if (option && this.listboxHasVisualFocus) {
      this.comboboxNode.setAttribute('aria-activedescendant', option.id);
      if (!this.isOptionInView(option)) {
        option.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    } else {
      this.comboboxNode.setAttribute('aria-activedescendant', '');
    }
  }

  setValue(value) {
    this.filter = value;
    this.comboboxNode.value = this.filter;
    this.sanitizeLocationString();
    this.updateSearchButtonState();
    this.comboboxNode.setSelectionRange(this.comboboxNode.value.length, this.comboboxNode.value.length);
  }

  setOption(option, flag) {
    if (option) {
      this.option = option;
      this.setCurrentOptionStyle(this.option);
      this.setActiveDescendant(this.option);
    }
  }

  setVisualFocusCombobox() {
    this.listboxNode.classList.remove('focus');
    this.comboboxNode.parentNode.classList.add('focus'); // set the focus class to the parent for easier styling
    this.comboboxHasVisualFocus = true;
    this.listboxHasVisualFocus = false;
    this.setActiveDescendant(false);
}

  setVisualFocusListbox() {
    this.comboboxNode.parentNode.classList.remove('focus');
    this.comboboxHasVisualFocus = false;
    this.listboxHasVisualFocus = true;
    this.listboxNode.classList.add('focus');
    this.setActiveDescendant(this.option);
  }

  removeVisualFocusAll() {
    this.comboboxNode.parentNode.classList.remove('focus');
    this.comboboxHasVisualFocus = false;
    this.listboxHasVisualFocus = false;
    this.listboxNode.classList.remove('focus');
    this.option = null;
    this.setActiveDescendant(false);
  }

  isPrintableCharacter(str) {
    return str.length === 1 && str.match(/\S| /);
  }

  sanitizeLocationString() {
    let testString = this.comboboxNode.value;

    // Remove any HTML tags from the string
    testString = testString.replace(/(<([^>]+)>)/gi, ' ');

    // strip smart apostrophes from string (happens on Apple devices)
    testString = testString.replace(/[\u2018\u2019]+/gi,'\'');

    // remove any special characters
    testString = testString.replace(/[^0-9a-zA-Z\s,\']+/gi, ' ');

    // strip leading spaces left by replace
    testString = testString.trimStart();

    this.comboboxNode.value = testString;

    return true;

  }

  updateSearchButtonState() {
    let disabled = true;
    if ( this.isSearchResultsForm ) {
      if ( this.comboboxNode.value.length && this.comboboxNode.value !== this.initialLocation ) {
        disabled = false;
      }
    } else {
        if ( this.comboboxNode.value.length ) {
          disabled = false;
        }
    }
    if ( disabled ) {
      this.searchButton.setAttribute('aria-disabled', 'true');
      this.searchButton.setAttribute('type', 'button');
    } else {
      this.searchButton.setAttribute('aria-disabled', 'false');
      this.searchButton.setAttribute('type', 'submit');
    }
  }

  createSuggestionGroupSeparator(groupName) {
    let ligroup = document.createElement('li');
    ligroup.id = `lbl-group-${groupName}`;
    ligroup.setAttribute('role', 'separator');
    ligroup.setAttribute('aria-disabled', 'true');

    ligroup.innerHTML = `
        <div class="suggestionGroup">
            <p class="groupName">
                ${groupName}
            </p>
        </div>
    `;

    return ligroup;
  }

  createSuggestionOption( index, suggestionType, title, subtitle, iconClass ) {
    let li = document.createElement('li');
    li.id = `lbl-${index}`;
    li.classList.add('autosuggest-option');
    li.setAttribute('role', 'option');
    li.setAttribute('data-suggestion-type', suggestionType);

    li.innerHTML = `
        <div class="suggestionLink">
            <div class="suggestion">
                <div class="suggestionIcon">
                    <span class="${iconClass}"></span>
                </div>
                <div class="suggestionText" >
                    <p class="suggestionTitle">${title}</p>
                    <p class="suggestionSubtitle">${subtitle}</p>
                </div>
            </div>
        </div>`;

    return li;
  }

  createDevelopmentSuggestionsGroup() {
    // get the suggested developments
    let developments = suggestedDevelopments.getSuggestions(this.comboboxNode.value);

    if (developments.length) {
      let liGroup = this.createSuggestionGroupSeparator('Developments');
      this.listboxElements.push(liGroup);

      let maxSuggestions = Math.min(developments.length, this.MAX_DEV_SUGGESTIONS);
      for (let i = 0; i < maxSuggestions; i++) {

        let li = this.createSuggestionOption(i, 'development', developments[i].name, developments[i].location, 'icon-home');

        this.suggestionOptions.push(li);
        this.listboxElements.push(li);
      }
    }
  }

  createLocationSuggestionGroup(suggestions) {
    if (suggestions.length) {
      let liGroup = this.createSuggestionGroupSeparator('Locations');
      this.listboxElements.push(liGroup);
      let maxSuggestions = Math.min(suggestions.length, this.MAX_SUGGESTIONS - this.suggestionOptions.length);
      for (let i = 0; i < maxSuggestions; i++) {
        let li = this.createSuggestionOption(i, 'location', suggestions[i].title, suggestions[i].subtitle, 'icon-location');
        this.listboxElements.push(li);
        this.suggestionOptions.push(li);
      }
    }
  }

  getOptionValue( option ) {
    let value = '';
    let title = option.querySelector('.suggestionTitle');
    if (option.dataset.suggestionType === 'development') {
      value = title.textContent;
    } else {
      let subtitle = option.querySelector('.suggestionSubtitle');
      value = `${title.textContent}, ${subtitle.textContent}`;
    }
    return value;
  }

  filterOptions() {

    this.suggestionOptions = [];
    this.listboxElements = [];
    if (!this.suggestionsLoading) {
      this.suggestionsLoading = true;

      this.autoSuggestManager.getSuggestions(this.comboboxNode.value, (suggestions, query) => {
        this.createDevelopmentSuggestionsGroup();
        this.createLocationSuggestionGroup(suggestions);

        let option = null;
        let currentOption = this.option;

        this.filteredOptions = [];
        this.listboxNode.innerHTML = '';


        for (let listboxElement of this.listboxElements) {
          this.listboxNode.appendChild(listboxElement);
        }

        for (let option of this.suggestionOptions) {
          this.filteredOptions.push(option);
          option.addEventListener('click', this.onOptionClick.bind(this));
          option.addEventListener('pointerover', this.onOptionPointerover.bind(this));
          option.addEventListener('pointerout', this.onOptionPointerout.bind(this));
        }

        // Use populated options array to initialize firstOption and lastOption.
        let numItems = this.filteredOptions.length;
        if (numItems > 0) {
          this.firstOption = this.filteredOptions[0];
          this.lastOption = this.filteredOptions[numItems - 1];

          if (currentOption && this.filteredOptions.indexOf(currentOption) >= 0) {
            option = currentOption;
          } else {
            option = this.firstOption;
          }
        } else {
          this.firstOption = null;
          option = null;
          this.lastOption = null;
        }
        if (option) {
          if (this.isClosed() && this.comboboxNode.value.length) {
            this.open();
          }

          if (
            this.getLowercaseContent(option).indexOf(
              this.comboboxNode.value.toLowerCase()
            ) === 0
          ) {
            this.option = option;
          } else {
            this.option = null;
            this.setCurrentOptionStyle(false);
          }
        } else {
          this.close();
          this.option = null;
          this.setActiveDescendant(false);
        }
        this.suggestionsLoading = false;
      });
    } else {
      if (typeof this.timeoutID === 'number') {
        window.clearTimeout(this.timeoutID);
      }
      let that = this;
      this.timeoutID = window.setTimeout(function () {
        that.suggestionsLoading = false;
        that.filterOptions();
      }, 100);

    }
    return true;
  }

  setCurrentOptionStyle(option) {
    for (let opt of this.filteredOptions) {
      if (opt === option) {
        opt.setAttribute('aria-selected', 'true');
        if (
          this.listboxNode.scrollTop + this.listboxNode.offsetHeight <
          opt.offsetTop + opt.offsetHeight
        ) {
          this.listboxNode.scrollTop =
            opt.offsetTop + opt.offsetHeight - this.listboxNode.offsetHeight;
        } else if (this.listboxNode.scrollTop > opt.offsetTop + 2) {
          this.listboxNode.scrollTop = opt.offsetTop;
        }
      } else {
        opt.removeAttribute('aria-selected');
      }
    }
  }

  getPreviousOption(currentOption) {
    if (currentOption !== this.firstOption) {
      let index = this.filteredOptions.indexOf(currentOption);
      return this.filteredOptions[index - 1];
    }
    return this.lastOption;
  }

  getNextOption(currentOption) {
    if (currentOption !== this.lastOption) {
      let index = this.filteredOptions.indexOf(currentOption);
      return this.filteredOptions[index + 1];
    }
    return this.firstOption;
  }

  /* MENU DISPLAY METHODS */

  doesOptionHaveFocus() {
    return this.comboboxNode.getAttribute('aria-activedescendant') !== '';
  }

  isOpen() {
    return this.listboxNode.style.display === 'block';
  }

  isClosed() {
    return this.listboxNode.style.display !== 'block';
  }

  hasOptions() {
    return this.filteredOptions.length;
  }

  open() {
    this.listboxNode.style.display = 'block';
    this.comboboxNode.setAttribute('aria-expanded', 'true');
  }

  close(force) {
    if (typeof force !== 'boolean') {
      force = false;
    }

    if (
      force ||
      (!this.comboboxHasVisualFocus &&
        !this.listboxHasVisualFocus &&
        !this.hasHover)
    ) {
      this.setCurrentOptionStyle(false);
      this.listboxNode.style.display = 'none';
      this.comboboxNode.setAttribute('aria-expanded', 'false');
      this.setActiveDescendant(false);
      this.comboboxNode.parentNode.classList.add('focus');
    }
  }

  /* combobox Events */

  onComboboxKeyDown(event) {
    let flag = false;
    let altKey = event.altKey;

    // keep copy of field value incase it is needed in the keyUp event handler
    this.keyDownFieldValue = this.comboboxNode.value;

    if (event.ctrlKey || event.shiftKey) {
      return;
    }

    switch (event.key) {
      case 'Enter':
        if (this.listboxHasVisualFocus) {
          let value = this.getOptionValue(this.option);
          this.setValue(value);
          if ( this.option.dataset.suggestionType === 'development' ) {
            this.searchButton.click();
          }
        } else if ( this.comboboxHasVisualFocus ) {
          if ( this.comboboxNode.value.length ) {
            this.searchButton.click();
          }
        }
        this.close(true);
        this.setVisualFocusCombobox();
        flag = true;
        break;

      case 'Down':
      case 'ArrowDown':
        if (this.filteredOptions.length > 0) {
          if (altKey) {
            this.open();
          } else {
            if (this.isOpen()) {
              if (this.listboxHasVisualFocus) {
                this.setOption(this.getNextOption(this.option), true);
                this.setVisualFocusListbox();
              } else {
                this.setOption(this.firstOption, true);
                this.setVisualFocusListbox();
              }
            } else {
              this.filterOptions();
            }
          }
        }

        flag = true;
        break;

      case 'Up':
      case 'ArrowUp':
        if (this.hasOptions()) {
          if (this.listboxHasVisualFocus) {
            this.setOption(this.getPreviousOption(this.option), true);
          } else {
            this.open();
            if (!altKey) {
              this.setOption(this.lastOption, true);
              this.setVisualFocusListbox();
            }
          }
        }
        flag = true;
        break;

      case 'Esc':
      case 'Escape':
        if (this.isOpen()) {
          this.close(true);
          this.filter = this.comboboxNode.value;
          this.setVisualFocusCombobox();
        } else {
          this.setValue('');
        }
        this.option = null;
        flag = true;
        break;

      case 'Tab':
        this.close(true);
        if (this.listboxHasVisualFocus) {
          if (this.option) {
            let value = this.getOptionValue(this.option);
            this.setValue(value);
          }
        }
        break;

      case 'Home':
        this.comboboxNode.setSelectionRange(0, 0);
        flag = true;
        break;

      case 'End':
        let length = this.comboboxNode.value.length;
        this.comboboxNode.setSelectionRange(length, length);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onComboboxKeyUp(event) {
    let flag = false;
    let char = event.key;

    // check we have a valid key, if not try to work out what it was. This happens with some android onscreen keyboards 
    if ( event.keyCode === 0 || event.keyCode === 229 ) {
      let charsChanged = this.comboboxNode.value.length - this.keyDownFieldValue.length;
      // if a character was added - then Character pressed
      if (charsChanged === 1) {
        char = this.comboboxNode.value.slice(-1);
        // else if a character was removed then key was a backspace
      } else if (charsChanged === -1) {
        char = 'Backspace';
      } else if (charsChanged > 1) {
        // Some mobile devices offer suggestions which trigger a keyUp event
        this.setValue(this.comboboxNode.value);
        this.filterOptions();
        return;
      }
    }

    if (this.isPrintableCharacter(char)) {
      this.filter += char;
    }

    if (char === 'Escape' || char === 'Esc') {
      return;
    }

    switch (char) {
      case 'Backspace':
        this.setVisualFocusCombobox();
        this.setCurrentOptionStyle(false);
        this.filter = this.comboboxNode.value;
        this.option = null;
        this.updateSearchButtonState();
        if (this.comboboxNode.value.length) {
          this.filterOptions();
        } else {
          this.close(true);
        }
        flag = true;
        break;

      case 'Left':
      case 'ArrowLeft':
      case 'Right':
      case 'ArrowRight':
      case 'Home':
      case 'End':
        this.option = null;
        this.setCurrentOptionStyle(false);
        this.setVisualFocusCombobox();
        flag = true;
        break;

      default:
        if (this.isPrintableCharacter(char)) {
          this.setVisualFocusCombobox();
          this.setCurrentOptionStyle(false);
          this.sanitizeLocationString();
          this.updateSearchButtonState();
          flag = true;
          this.filterOptions();
        }

        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onComboboxClick() {
    if (this.isOpen()) {
      this.close(true);
    } else {
      if (this.comboboxNode.value.length) {
        this.filterOptions();
      }
    }
  }

  onComboboxFocus() {
    this.filter = this.comboboxNode.value;
    this.setVisualFocusCombobox();
    this.option = null;
    this.setCurrentOptionStyle(null);
  }

  onComboboxBlur() {
    this.removeVisualFocusAll();
    window.setTimeout(this.close.bind(this, true), 300);
  }

  onComboboxCut() {
    // use timeout to wait for value to be cut
    let that = this;
    window.setTimeout(() => {
      that.sanitizeLocationString();
      that.updateSearchButtonState();
      
      that.filter = that.comboboxNode.value;
      if (!that.filter.length) {
        that.close(true);
      } else {
        that.setVisualFocusCombobox();
        that.option = null;
        that.filterOptions();
        that.setCurrentOptionStyle(null);
      }
    });
  }

  onComboboxPaste() {
    // use timeout to wait for value to be pasted
    let that = this;
    window.setTimeout(() => {
      that.sanitizeLocationString();
      that.updateSearchButtonState();
      that.filter = that.comboboxNode.value;
      that.setVisualFocusCombobox();
      that.option = null;
      that.filterOptions();
      that.setCurrentOptionStyle(null);
    });
  }

  onBackgroundPointerUp(event) {
    if (
      !this.comboboxNode.contains(event.target) &&
      !this.listboxNode.contains(event.target) 
    ) {
      this.comboboxHasVisualFocus = false;
      this.setCurrentOptionStyle(null);
      this.removeVisualFocusAll();
      window.setTimeout(this.close.bind(this, true), 300);
    }
  }

  /* Listbox Events */

  onListboxPointerover() {
    this.hasHover = true;
  }

  onListboxPointerout() {
    this.hasHover = false;
    window.setTimeout(this.close.bind(this, false), 300);
  }

  // Listbox Option Events
  getOptionClicked( event ) {
    let option = null;
    if (event.target.classList.contains('autosuggest-option')) {
      option = event.target;
    } else {
      option = event.target.closest('.autosuggest-option');
    }

    return option;
  }

  onOptionClick(event) {
    let option = this.getOptionClicked(event);
    let value = this.getOptionValue(option);
    this.setValue(value);
    if ( option.dataset.suggestionType === 'development' ) {
      this.searchButton.click();
    }
    this.close(true);
  }

  onOptionPointerover() {
    this.hasHover = true;
    this.open();
  }

  onOptionPointerout() {
    this.hasHover = false;
    window.setTimeout(this.close.bind(this, false), 300);
  }
}